import { useStyles } from '../style';

interface CellProps {
  mobile: JSX.Element;
  desktop: JSX.Element;
}

const ViewportControlCell = ({ mobile, desktop }: CellProps) => {
  const classes = useStyles({});

  return (
    <>
      <div className={classes.onlyMobile}>{mobile}</div>
      <div className={classes.onlyDesktop}>{desktop}</div>
    </>
  );
};

export default ViewportControlCell;
